"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValue = exports.generateProviderSDRN = void 0;
var PROVIDER_ID_UNDEFINED = '--PROVIDER-ID-NOT-DEFINED--';
var DEFAULT_PROVIDER_TYPE = 'Organization';
function generateProviderSDRN(providerId) {
    if (providerId) {
        return "sdrn:schibsted:client:".concat(providerId);
    }
    return PROVIDER_ID_UNDEFINED;
}
exports.generateProviderSDRN = generateProviderSDRN;
function provider(input) {
    var providerInput = (input || {}).provider;
    var _a = providerInput || {}, id = _a.id, _b = _a.type, type = _b === void 0 ? DEFAULT_PROVIDER_TYPE : _b, rest = __rest(_a, ["id", "type"]);
    var base = {
        '@type': type,
        '@id': generateProviderSDRN(id),
    };
    return Object.assign({}, base, rest);
}
exports.default = provider;
var defaultValue = function () { return undefined; };
exports.defaultValue = defaultValue;
